import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTopHandler() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      let cancelled = false;

      // scrollIntoView resolves position live at call time (honoring each
      // target's CSS scroll-margin-top), so it's immune to the stale-position
      // bug a manually-measured window.scrollTo had when fonts/layout were
      // still settling. Double rAF just ensures the element is mounted.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (cancelled) return;
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'auto', block: 'start' });
        }
      }));

      return () => {
        cancelled = true;
      };
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}

export default ScrollToTopHandler;